import difference from "lodash-es/difference";

import { StaffDetailsFormData } from "./components/StaffDetailsPage";
import { StaffMemberDetails_staff } from "./types/StaffMemberDetails";

/**
 * Return lists of groups which have to be added and removed from user.
 */
export const groupsDiff = (
  user: StaffMemberDetails_staff,
  formData: StaffDetailsFormData
) => {
  const newGroups = formData.permissionGroups;
  const oldGroups = user.permissionGroups.map(u => u.id);

  return {
    addGroups: difference(newGroups, oldGroups),
    removeGroups: difference(oldGroups, newGroups)
  };
};
